import { EmailTemplatesTable } from "features/templates/email";

export { EmailTemplatesTable };

export const EmailTemplatesPage = () => {
  return <EmailTemplatesTable />;
};
